import React from "react";

const Footer = () => {
  return (
    <footer className="mt-5 p-3 text-center bg-light">
      <h2>
        <a href="https://www.linkedin.com/in/alexriosj/">
          <i className="fab fa-linkedin mx-3" />
        </a>
        <a href="https://www.github.com/alexriosj/fav-gifs-app">
          <i className="fab fa-github mx-3" />
        </a>
        <a href="https://www.twitter.com/alexrios979">
          <i className="fab fa-twitter mx-3" />
        </a>
      </h2>
    </footer>
  );
};

export default Footer;
